export enum IOrderDetailActionTypes {
  PRINT = 'PRINT',
  DOWNLOAD_INVOICES = 'DOWNLOAD_INVOICES',
}

export interface IOrderDetailAction {
  actionType: IOrderDetailActionTypes;
  displayName: string;
  icon?: string;
}
